export default function createStyles(styles) {
  return styles;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/createStyles/createStyles.js
// module id = 1508
// module chunks = 1